export default __webpack_public_path__ + "static/media/7.74ff6c6c.png";